import { useInfiniteQuery } from '@tanstack/react-query';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { ExercisesListParams } from '@src/api/exercises.ts';
import { API } from '@src/api/index.ts';

export const useExercisesInfiniteQuery = (params: Omit<ExercisesListParams, 'page' | 'module'>) => {
  const { moduleId } = useModuleByCodeParam();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['exercises', { ...params, moduleId }],
    queryFn: async ({ pageParam = 1 }) =>
      await API.exercises.getList({
        ...params,
        page: pageParam,
        module: moduleId,
      }),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const { next } = lastPage;
      return next ? lastPageParam + 1 : undefined;
    },
    select: (data) => {
      return {
        ...data,
        results: data?.pages.flatMap((page) => page.results),
      };
    },
  });
};
